import React, { useEffect, useState } from "react";
import SideNav from "./page-essential/SideNav";
import { BookingRecord, IBookingRes } from "../helpers/types/global";
import BookingService from "../services/BookingService";

const tableHeaders = [
  {
    id: 0,
    title: "date",
  },
  {
    id: 1,
    title: "email",
  },
  {
    id: 2,
    title: "name",
  },
  {
    id: 3,
    title: "country",
    img: true,
  },
  {
    id: 4,
    title: "group_members",
  },
  {
    id: 5,
    title: "package",
  },
  {
    id: 6,
    title: "departure_date",
  },
  {
    id: 7,
    title: "message",
  },
  {
    id: 8,
    title: "phone",
  },
];

const Booking = () => {
  const [data, setData] = useState<BookingRecord[]>([]);
  const fetchBooking = async () => {
    try {
      const dbRes = await BookingService.fetchBookings("");
      setData(dbRes.data.data.records);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBooking();
  }, []);

  return (
    <div>
      <SideNav>
        <div className="mt-8 lg:mt-12">
          <div className="flex items-center space-x-2">
            <h1 className="text-2xl font-semibold">Booking</h1>
          </div>
          <p className="text-gray-500 mt-2">View all the booking details </p>

          {/* booking table  */}

          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-8">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="h-12">
                <th className="px-3" scope="col">
                  #
                </th>
                {tableHeaders.map((item: any, i: number) => {
                  return (
                    <th key={i} className="capitalize" scope="col">
                      {item.title.replaceAll("_", " ")}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody className="text-[16px]">
              {data.map((item, i) => (
                <tr
                  key={item.id}
                  className="h-12 border-b border-b-gray-300  transition-all hover:shadow-md"
                >
                  <td>{i + 1}</td>
                  <td>{new Date(item.createdAt).toDateString()}</td>
                  <td>{item.email}</td>
                  <td>{item.name}</td>
                  <td>{item.country}</td>
                  <td>{item.group_members}</td>
                  <td>{item.pkg.title}</td>
                  <td>{new Date(item.departure_date).toDateString()}</td>
                  <td>{item.message}</td>
                  <td>{item.phone}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SideNav>
    </div>
  );
};

export default Booking;
